module.exports = __webpack_public_path__ + "static/media/clear.61e585cb.svg";